export default __webpack_public_path__ + "static/media/002-house.7ec1193f.png";